// The Agent Kingdom roster — every house on the world maps.
//
// This is structure, not state: live status / task / up-next come from the
// `agents` collection (written by Grok Bot through the CRM MCP server).
// KEEP IN SYNC with functions/mcp/agentRoster.js — the MCP tools refuse ids
// that are not in that list. Ids are slugified names and must match keys in
// config/layout.js.
//
// [world, district, name, autonomous]  autonomous=false → drafts for approval

import { slugify } from "./worlds";

const ROSTER_ROWS = [
  // ---------- LEADS ----------
  ["leads", "Sourcing", "Prospect Miner", true],
  ["leads", "Sourcing", "Social Listener", true],
  ["leads", "Outreach", "Outbound Sequencer", false],
  ["leads", "Outreach", "Cold Caller", false],
  ["leads", "Outreach", "Social Prospector", true],
  ["leads", "Outreach", "Referral Agent", false],
  ["leads", "Outreach", "Reactivation Agent", true],
  ["leads", "Content", "Newsletter Agent", false],
  ["leads", "Content", "Content Repurposer", true],
  ["leads", "Content", "Engagement Agent", true],
  ["leads", "Content", "Campaign Agent", false],
  ["leads", "Pipeline", "Speed-to-Lead", true],
  ["leads", "Pipeline", "Qualifier", true],
  ["leads", "Pipeline", "Booking Agent", true],
  ["leads", "Pipeline", "Call Intelligence", true],
  ["leads", "Pipeline", "Analysis Builder", false],
  ["leads", "Pipeline", "Program Builder", false],
  ["leads", "Pipeline", "Stage Nurture", true],
  ["leads", "Command", "Lead Manager", false],

  // ---------- CLIENTS ----------
  ["clients", "Onboarding", "Onboarding Agent", true],
  ["clients", "Onboarding", "Intake Agent", true],
  ["clients", "Onboarding", "Systems Setup Agent", false],
  ["clients", "Planning", "Assessment & Goals", false],
  ["clients", "Planning", "Roadmap & Priorities", false],
  ["clients", "Coaches", "Sales Coach", true],
  ["clients", "Coaches", "Operations Coach", true],
  ["clients", "Coaches", "Technology Coach", true],
  ["clients", "Coaches", "Marketing Coach", true],
  ["clients", "Coaches", "Finance Coach", false],
  ["clients", "Coaches", "HR Coach", true],
  ["clients", "Retention", "Session Agent", true],
  ["clients", "Retention", "Accountability Agent", true],
  ["clients", "Retention", "Scorecard Agent", true],
  ["clients", "Retention", "Pulse Agent", true],
  ["clients", "Retention", "Renewal Agent", false],
  ["clients", "Retention", "Community Agent", true],
  ["clients", "Command", "Client Manager", false],

  // ---------- INTERNAL ----------
  ["internal", "Money", "Billing & Collections", false],
  ["internal", "Money", "Bookkeeping Agent", true],
  ["internal", "Money", "Finance Reporter", true],
  ["internal", "Admin", "Contracts & Records", false],
  ["internal", "Command", "Internal Ops Manager", true],
  ["internal", "Team", "Team & Tools Ops", true],
  ["internal", "Team", "Knowledge Base Agent", true],
  ["internal", "Team", "Portal Chief", true],
  ["internal", "Team", "Event Ops Agent", false],
  ["internal", "Work", "Task Orchestrator", true],
  ["internal", "Work", "Deliverables Tracker", true],
  ["internal", "Work", "Scheduler Agent", true],
];

export const ROSTER = ROSTER_ROWS.map(([world, district, name, autonomous]) => ({
  id: slugify(name),
  name,
  world,
  district,
  autonomous,
}));
